<script>
import StudentSvg from '@/assets/student.svg'
import HeaderTabsContent from '@/views/Layouts/HeaderTabsContent'

export default {
  extends: HeaderTabsContent,
  computed: {
    title() {
      return 'Biblioteka'
    },
    routes() {
      return [
        {
          label: 'Kursy',
          icon: 'laptop',
          to: `/kursant/biblioteka/kursy`
        },
        {
          label: 'Dla kursantów',
          iconComponent: StudentSvg,
          to: `/kursant/biblioteka/kursanci`
        }
      ]
    }
  }
}
</script>
